import React from 'react';
import { useModal } from 'utils';

export const CancelBtn = ({ text }) => {
    const { close } = useModal();

    return (
        <button onClick={close} className={`close-btn`}>
            <span>{text ? text : 'Cancel'}</span>
        </button>
    );
};
